// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import Button from '@liquidweb-dev/undercurrent/Button';
import BrandLogo from 'components/atoms/BrandLogo';
import { useLogout } from 'modules/oidc/useLogout';

/**
 * @param {object} props
 * @param {Omit<import('@liquidweb-dev/undercurrent/Button').ButtonProps, 'size'>} [props.logoutButtonProps]
 */
const LogoutOnly = ({ logoutButtonProps }) => {
	const logout = useLogout();

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 200,
				width: '100%',
			}}
		>
			<BrandLogo />
			<Button
				variant="link"
				onClick={logout}
				size="large"
				{...logoutButtonProps}
			>
				Logout
			</Button>
		</Box>
	);
};

export default LogoutOnly;
